@if (data.rows.length === 0) {
  <p class="empty">{{ 'dashboard.team.no_rolloff' | translate }}</p>
} @else {
  <table class="rolloff">
    <thead>
      <tr>
        <th>{{ 'dashboard.team.member' | translate }}</th>
        <th>{{ 'dashboard.team.col_client' | translate }}</th>
        <th>{{ 'dashboard.team.ends' | translate }}</th>
        <th class="num">{{ 'dashboard.team.col_capacity' | translate }}</th>
        <th class="num">
          {{ 'dashboard.team.col_revenue' | translate }}
          @if (!data.moneyVisible) { <nb-icon icon="lock-outline" class="lock" [title]="'dashboard.team.locked_money' | translate"></nb-icon> }
        </th>
      </tr>
    </thead>
    <tbody>
      @for (row of data.rows; track row.userId + row.endsOn) {
        <tr>
          <td class="name"><button type="button" class="row-action" (click)="pick(row)">{{ row.name }}</button></td>
          <td>{{ row.clientCount > 1 ? ('dashboard.team.multiple_clients' | translate) : (row.client ?? ('dashboard.unit.na' | translate)) }}</td>
          <td>{{ row.endsOn | date:'d MMM y' }}</td>
          <td class="num">{{ row.capacityReleased }} {{ 'dashboard.unit.hours_suffix' | translate }}</td>
          <td class="num">
            @if (data.moneyVisible) {
              {{ row.weeklyRevenue !== null && row.weeklyRevenue !== undefined ? ('€ ' + (row.weeklyRevenue | number:'1.0-0')) : ('dashboard.unit.na' | translate) }}
            } @else { <nb-icon icon="lock-outline" class="lock"></nb-icon> }
          </td>
        </tr>
      }
    </tbody>
  </table>
}
